/** Index the tablist moves to, or null when the key is not a navigation key.
 *  Wraps at both ends (WAI-ARIA APG tabs pattern). */
export function tabKeyboardTarget(key: string, currentIndex: number, count: number): number | null {
    if (count === 0) return null;

    const from = currentIndex < 0 ? 0 : currentIndex;

    switch (key) {
        case 'ArrowRight':
            return (from + 1) % count;
        case 'ArrowLeft':
            return (from - 1 + count) % count;
        case 'Home':
            return 0;
        case 'End':
            return count - 1;
        default:
            return null;
    }
}
